import type { QBusEventMap } from "@otto-ec/event-q-bus";

export type HistoryEvent = { historic: boolean };

export type FTFindEvents = QBusEventMap<{
  ["ftfind.history.merge"]: [
    {
      topic: string;
      data: {
        historic: boolean;
      };
    }
  ];
}>;

let isInitialized = false;
const headerElementClass = "js_find_header";
let headerElement: HTMLElement;
const searchbarInputElementClass = "js_squirrel_searchbar__input";
let searchbarInputElement: HTMLInputElement;
const searchbarAbortElementClass = "js_squirrel_searchline__abort";
let searchbarAbortElement;
const searchIconClass = "js_squirrel_searchIcon";
let searchIconElement;
const searchCurtainElementClass = "js_squirrel_searchCurtain";
let searchCurtainElement;
const searchbarVisibilityClass = "find_header--visibleSearchbar";
const searchbarActiveClass = "find_header--activeSearch";
const adaptedSpringBreakHeaderClass = "find_header--adaptedSpringBreak";
const preventBodyScrollingClass = "squirrel_preventScrolling";

export function hideSearchField() {
  headerElement.classList.remove(searchbarVisibilityClass);
}

export function showSearchField() {
  headerElement.classList.add(searchbarVisibilityClass);
}

export function _toggleSearchField() {
  const isVisible: boolean = headerElement.classList.contains(searchbarVisibilityClass);
  const trackingValue: string = isVisible ? "search_close" : "search_open";

  headerElement.classList.toggle(searchbarVisibilityClass);

  if (!isVisible) {
    searchbarInputElement.focus();
    window.o_global.eventQBus.emit("ftnav.global-navigation.close");
  }

  window.o_global.eventQBus.emit("tracking.bct.submitEvent", {
    san_Header: trackingValue,
  });
}

export function _toggleSearchBox(enable: boolean) {
  if (headerElement) {
    headerElement.classList.toggle(searchbarActiveClass, enable);

    const scrollingElement: Element = document.scrollingElement || document.documentElement;

    if (scrollingElement && headerElement.classList.contains(adaptedSpringBreakHeaderClass)) {
      scrollingElement.classList.toggle(preventBodyScrollingClass, enable);
    }
  }
}

export function _openSearch() {
  _toggleSearchBox(true);

  if (!headerElement.classList.contains(adaptedSpringBreakHeaderClass)) {
    window.o_global.eventQBus.emit("ftnav.global-navigation.close");
  }
}

export function _closeSearch() {
  _toggleSearchBox(false);
  searchbarInputElement.blur();

  window.o_global.eventQBus.emit("tracking.bct.submitEvent", {
    san_Header: "search_cancel",
  });
}

export function _registerHistoryEvents(event: HistoryEvent) {
  if (event && event.historic) {
    return;
  }

  window.o_global.events<FTFindEvents>().emit("ftfind.history.merge", {
    topic: "squirrel.search.close",
    data: {
      historic: true,
    },
  });

  // TODO: How to merge ftfind.history into squirrel?
  window.o_global.eventQBus.emit("ftfind.history.push", {
    topic: "squirrel.search.open",
    data: {
      historic: true,
    },
  });
}

export function _removeHistoryEvents(event: HistoryEvent) {
  if (event && event.historic) {
    return;
  }

  window.o_global.eventQBus.emit("ftfind.history.shift");
}

export function init() {
  if (!isInitialized) {
    searchbarInputElement = document.getElementsByClassName(searchbarInputElementClass)[0] as HTMLInputElement;
    searchIconElement = document.getElementsByClassName(searchIconClass)[0];
    headerElement = document.getElementsByClassName(headerElementClass)[0] as HTMLElement;
    searchbarAbortElement = document.getElementsByClassName(searchbarAbortElementClass)[0];
    searchCurtainElement = document.getElementsByClassName(searchCurtainElementClass)[0];

    if (searchIconElement && headerElement) {
      searchIconElement.addEventListener("click", _toggleSearchField);
    }

    if (searchbarInputElement) {
      searchbarInputElement.removeAttribute("disabled");
      searchbarInputElement.addEventListener("focus", function (event) {
        if (!!event.isTrusted && !headerElement.classList.contains(searchbarActiveClass)) {
          window.o_global.eventQBus.emit("squirrel.search.open");
        }
      });
    }

    if (searchbarAbortElement) {
      searchbarAbortElement.addEventListener("click", function () {
        if (!headerElement.classList.contains(adaptedSpringBreakHeaderClass)) {
          window.o_global.eventQBus.emit("squirrel.search.hide");
        }
        window.o_global.eventQBus.emit("squirrel.search.close");
      });
    }

    if (searchCurtainElement) {
      searchCurtainElement.addEventListener("click", function () {
        window.o_global.eventQBus.emit("squirrel.search.close");
      });
    }

    if (headerElement) {
      window.o_global.eventQBus.on("ftnav.global-navigation.opened", function () {
        showSearchField();
      });
      window.o_global.eventQBus.on("squirrel.search.open", function (event) {
        _openSearch();
        _registerHistoryEvents(event);
      });
      window.o_global.eventQBus.on("squirrel.search.close", function (event) {
        _closeSearch();
        _removeHistoryEvents(event);
      });
      window.o_global.eventQBus.on("squirrel.search.hide", function () {
        hideSearchField();
      });
      if (!headerElement.classList.contains(adaptedSpringBreakHeaderClass)) {
        window.o_global.eventQBus.on("ftnav.global-navigation.opened", function () {
          hideSearchField();
        });
      }
    }

    isInitialized = true;
  }
}

export interface Searchbar {
  init: () => void;
  hideSearchField: () => void;
  showSearchField: () => void;
}

export const searchbar = { init, hideSearchField, showSearchField };
